import useCheckoutStore from '@/store/checkout.store';
import useCart from '@/store/cart.store';
import { deleteCookie } from 'cookies-next';
import { signOut, useSession } from 'next-auth/react';
import { useLocale } from 'next-intl';
import { event_user_auth } from '@/utils/gtm';
import useGlobalStore from '@/store/global.store';
import useShippingInfoStore from '@/store/shipping-info.store';
import { useRouter } from 'next/navigation';
const useLogout = () => {
  const clearCheckout = useCheckoutStore((state) => state.clearCheckout);
  const resetCart = useCart((state) => state.resetCart);
  const locale = useLocale();
  const {push} = useRouter()
  const {data:session} = useSession()
  const { setIsOldUser } = useGlobalStore();
  const clearShippingInfo = useShippingInfoStore(
    (state) => state.clearShippingInfo
  );

  const logOut = async () => {
    event_user_auth(session?.user, 'user_logout_event', 'Logout');
    deleteCookie('mage');
    deleteCookie('isPharmacist');
    deleteCookie('adminId');
    await signOut({ redirect: false });
    setIsOldUser(false);
    deleteCookie('quote');
    resetCart();
    clearCheckout();
    clearShippingInfo();
    push(`/${locale === 'ar' ? '' : locale}`);
  };
  return logOut;
};

export default useLogout;
